<template>
  <div class="loading-page">
    <div class="counter">
      <a class="navbar-brand" href="">
        <img class="img-responsive  myImages" src="../../assets/images/Logo-01.png" width="180" height="80"/></a>
      <br><br><br>
      <h6 style="padding: 17px 24px; color:#141619 "> درحال انتقال به بخش آزمون لطفا شکیبا باشید...</h6> <br>
     <div class="progress" style="    background: rgba(0, 0, 0, 0.125);">
        <div class="progress-bar progress-bar-striped bg-danger"  id="counterHr" role="progressbar"  aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"  v-html="numbers_in"></div>
      </div>
    </div>
  </div>
  <div class="overflow-hidden" >
     <slot/>
  </div>
</template>
<script>
import LoadingFull from "./sub/loadingFull.vue"
export default {
  name: "index",
  data() {
    return {
      counter: 0,
      number: 0,
      numbers_in: "",
      status: "",
    }
  },
  mounted() {
    this.status = setInterval(() => {
      this.loading()
    }, 200)
  },
  methods: {
    loading: function () {
      if (this.status === false)
        return false;
      if (this.number === 100) {
        clearInterval(this.status)
        return true;
      }
      this.number += 1;
      let i = document.getElementById("counterHr").style.width = this.number - 1 + "%";
      this.numbers_in = this.number + '%';
    }
  }

}
</script>
<style scoped>

</style>